import React from 'react';
import { useTranslation } from 'react-i18next';

import AlertMessage from '../../../prime/common/Components/AlertMessage';

interface DisplayErrorMessageProps {
    validation: boolean;
    messageTxt?: string | null;
}

const DisplayErrorMessage: React.FC<DisplayErrorMessageProps> = (props) => {
    const { t } = useTranslation();
    if (props.validation) {
        return (
            <AlertMessage msg={props.messageTxt ? props.messageTxt : t('defaultErrorMessage')} type={'error'} />
        );
    }
    return null;
};
export default DisplayErrorMessage;
